export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email',
    'Phone'
  ],
  'requiredFields': {
    'default': [
      'Company',
      'PostalCode'
    ],
    'consulting': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'offersGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'offersInvestment': [
      'PostalCode'
    ],
    'other': [
      'RequestMessage'
    ],
    'customer_serviceGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic',
      'RequestMessage'
    ],
    'customer_serviceBank': [
      'RequestTopic',
      'RequestMessage'
    ],
    'investor_relations': [
      'RequestMessage'
    ],
    'career': [
      'RequestMessage'
    ],
    'press': [
      'RequestMessage'
    ],
    'cooperation': [
      'Company',
      'PostalCode',
      'RequestTopic',
      'RequestMessage'
    ]
  }
}
